import {ChangeEvent, useEffect, useState} from "react"
import {Icon} from "semantic-ui-react"


interface CustomHeaderProps {
    date: Date
    intlLocale: string
    decreaseMonth: () => void
    increaseMonth: () => void
    changeYear: (year: number) => void
}

export function DatePickerHeader({ date, decreaseMonth, increaseMonth, changeYear, intlLocale }: CustomHeaderProps) {
    const [yearInput, setYearInput] = useState(date.getFullYear().toString())

    /**
     * Sync yearInput whenever date changes.
     */
    useEffect(() => setYearInput(date.getFullYear().toString()), [date])

    const handleYearChange = (e: ChangeEvent<HTMLInputElement>) => {
        const sanitizedInput = e.target.value.replace(/\D/g, "").slice(0, 4)
        setYearInput(sanitizedInput)
        if (sanitizedInput)
            changeYear(parseInt(sanitizedInput, 10))
    }

    return (
        <div className="react-datepicker-buttons">
            <Icon name="step backward" onClick={decreaseMonth}/>
            <span>{date.toLocaleString(intlLocale, { month: "long" })}</span>
            <Icon name="step forward" onClick={increaseMonth} />
            <Icon name="fast backward" onClick={() => changeYear(date.getFullYear() - 1)} />
            <input maxLength={4} value={yearInput} onChange={handleYearChange} />
            <Icon name="fast forward" onClick={() => changeYear(date.getFullYear() + 1)} />
        </div>
    )
}
